<template>
  <div class="block-form">
    <div class="form-field">
      <div class="form-label">Columnas</div>
      <q-btn-toggle
        :model-value="block.columns"
        :options="columnOptions"
        unelevated
        dense
        no-caps
        toggle-color="primary"
        @update:model-value="emit('update', { ...block, columns: $event })"
      />
    </div>

    <div class="form-label" style="margin-bottom: 4px;">Cards (max 12)</div>

    <div
      v-for="(card, idx) in block.cards"
      :key="idx"
      class="card-block"
    >
      <div class="card-header">
        <span class="card-number">Card {{ idx + 1 }}</span>
        <q-btn
          flat
          dense
          round
          icon="delete"
          color="negative"
          size="sm"
          @click="removeCard(idx)"
        >
          <q-tooltip>Eliminar card</q-tooltip>
        </q-btn>
      </div>
      <q-input
        outlined
        dense
        :model-value="card.icon"
        label="Icono (ej: waves)"
        hint="Nombre de icono de Material Icons"
        @update:model-value="updateCard(idx, 'icon', String($event ?? ''))"
      />
      <q-input
        outlined
        dense
        :model-value="card.title"
        label="Título"
        @update:model-value="updateCard(idx, 'title', String($event ?? ''))"
      />
      <q-input
        outlined
        dense
        type="textarea"
        rows="2"
        :model-value="card.body"
        label="Cuerpo"
        @update:model-value="updateCard(idx, 'body', String($event ?? ''))"
      />
      <q-input
        outlined
        dense
        :model-value="card.accent"
        label="Acento (color hex, opcional)"
        placeholder="#2e7fb5"
        @update:model-value="updateCard(idx, 'accent', String($event ?? ''))"
      />
    </div>

    <q-btn
      v-if="block.cards.length < 12"
      flat
      no-caps
      icon="add"
      label="Agregar card"
      color="primary"
      size="sm"
      @click="addCard"
    />
  </div>
</template>

<script setup lang="ts">
interface GridCard {
  icon?: string;
  title: string;
  body: string;
  accent?: string;
}

interface GridBlock {
  type: 'grid';
  columns: 2 | 3 | 4;
  cards: GridCard[];
}

const props = defineProps<{ block: GridBlock }>();
const emit = defineEmits<{ (e: 'update', block: GridBlock): void }>();

const columnOptions = [
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
];

function updateCard(idx: number, field: keyof GridCard, value: string) {
  const cards = props.block.cards.map((c, i) =>
    i === idx ? { ...c, [field]: value } : c,
  );
  emit('update', { ...props.block, cards });
}

function removeCard(idx: number) {
  const cards = props.block.cards.filter((_, i) => i !== idx);
  emit('update', { ...props.block, cards });
}

function addCard() {
  const cards = [...props.block.cards, { icon: '', title: '', body: '', accent: '' }];
  emit('update', { ...props.block, cards });
}
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.form-label {
  font-size: 13px;
  color: var(--oa-text-muted);
  margin-bottom: 6px;
}
.card-block {
  border: 1px solid var(--oa-border);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--oa-bg-2);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-number {
  font-size: 13px;
  font-weight: 600;
  color: var(--oa-text-secondary);
}
</style>
